/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Setup_Distribution_DiscountInputs */

const en_setup_distribution_discount = /** @type {(inputs: Setup_Distribution_DiscountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distribution discount`)
};

/**
* | output |
* | --- |
* | "Distribution discount" |
*
* @param {Setup_Distribution_DiscountInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const setup_distribution_discount = /** @type {((inputs?: Setup_Distribution_DiscountInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Setup_Distribution_DiscountInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_setup_distribution_discount(inputs)
});